import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles<void, string>()(
  ({ palette, tokens, px }, _, classes) => ({
    selectInput: {
      width: '100%',
      marginBottom: tokens.spacing['16'],

      '& .MuiSelect-icon.Mui-disabled': {
        color: tokens.colors.text.light.tertirary,
      },
    },

    withoutMargins: {
      marginBottom: 0,
    },

    inputRoot: {
      '& .MuiInputBase-root': {
        paddingRight: 0,
        lineHeight: 1.5,
        backgroundColor: tokens.colors.bg.light.primary,

        '&.MuiOutlinedInput-root.MuiAutocomplete-inputRoot': {
          padding: 0,
        },

        '&.MuiOutlinedInput-root.MuiAutocomplete-inputRoot .MuiInputBase-input, &.MuiOutlinedInput-root .MuiSelect-root':
          {
            height: px(24),
            paddingTop: tokens.spacing['16'],
            paddingRight: tokens.spacing['72'],
            paddingBottom: tokens.spacing['16'],
            paddingLeft: tokens.spacing['16'],
          },

        '& .MuiSelect-iconOutlined': {
          right: tokens.spacing['16'],
        },

        '&.Mui-focused': {
          '& fieldset': {
            borderColor: tokens.colors.original.brand.primary,
            borderWidth: tokens.border.s,
          },

          [`& .${classes.clearButton}`]: {
            display: 'flex',
          },
        },

        '&.Mui-error': {
          backgroundColor: tokens.colors.accent.bg.error,

          '& fieldset': {
            borderColor: tokens.colors.accent.stroke.error,
          },

          '&.Mui-focused': {
            '& fieldset': {
              borderColor: tokens.colors.accent.text.error,
            },
          },

          '&:hover': {
            '& fieldset': {
              borderColor: palette.error.hover,
            },
          },
        },

        '&.Mui-disabled': {
          backgroundColor: tokens.colors.bg.greyscale.secondary,

          '& fieldset': {
            borderColor: tokens.colors.stroke.primary,
          },
        },

        '& fieldset': {
          borderColor: tokens.colors.stroke.primary,
        },

        '&:hover:not(.Mui-disabled):not(.Mui-error)': {
          '& fieldset': {
            borderColor: tokens.colors.stroke.secondary,
          },

          [`& .${classes.clearButton}`]: {
            display: 'flex',
          },
        },

        '& .MuiIconButton-root:hover': {
          backgroundColor: 'transparent',
        },

        '& .MuiAutocomplete-endAdornment': {
          right: tokens.spacing['16'],

          '& .MuiAutocomplete-clearIndicator': {
            marginRight: -tokens.spacing['2'],
            backgroundColor: 'transparent',

            '& .MuiTouchRipple-root': {
              display: 'none',
            },
          },

          '& .MuiAutocomplete-popupIndicator .MuiTouchRipple-root': {
            display: 'none',
          },
        },
      },

      '& .MuiFormHelperText-root.Mui-error': {
        marginLeft: 0,
        marginRight: 0,
      },
    },

    placeholder: {
      color: tokens.colors.text.light.tertirary,
    },

    menuItem: {
      fontSize: tokens.typography.variant.body3.fontSize,
      whiteSpace: 'normal',
      lineHeight: tokens.typography.variant.body3.lineHeight,
      '&:hover': {
        backgroundColor: tokens.colors.bg.greyscale.secondary,

        '&.Mui-selected': {
          backgroundColor: tokens.colors.bg.greyscale.secondary,
        },

        '& .MuiButtonBase-root.MuiCheckbox-root:not(.Mui-checked) svg path': {
          fill: tokens.colors.stroke.secondary,
        },
      },

      '& .MuiButtonBase-root.MuiCheckbox-root': {
        marginLeft: px(3), // TODO - fix нет в токенах
      },

      '&, &.Mui-selected': {
        backgroundColor: tokens.colors.bg.light.primary,
      },

      '&.Mui-selected .MuiTypography-root[class*=body3]': {
        color: tokens.colors.original.brand.primary,
      },

      '&.Mui-disabled .MuiTypography-root[class*=body3]': {
        color: tokens.colors.text.light.tertirary,
      },
    },

    additionalOption: {
      opacity: 1,
    },

    multiple: {
      '&.Mui-selected .MuiTypography-root[class*=body3]': {
        color: tokens.colors.text.light.primary,
      },
    },

    list: {
      boxShadow: tokens.shadow.l,
      overflowY: 'hidden',

      '& ul': {
        maxHeight: px(272),
        overflowY: 'auto',
      },
    },

    autocompleteList: {
      margin: `${tokens.spacing[4]}px 0`,
    },

    longList: {
      '& ul': {
        maxHeight: px(356),
      },
    },

    option: {
      paddingTop: tokens.spacing['8'],
      paddingRight: tokens.spacing['16'],
      paddingBottom: tokens.spacing['8'],
      paddingLeft: tokens.spacing['16'],
      fontSize: tokens.typography.variant.body3.fontSize,
      lineHeight: tokens.typography.variant.body3.lineHeight,
      cursor: 'pointer',

      '&:hover': {
        backgroundColor: tokens.colors.bg.greyscale.secondary,
      },

      '&[aria-selected=true]': {
        '&&&': {
          backgroundColor: tokens.colors.bg.light.primary,
        },

        '&:hover': {
          backgroundColor: tokens.colors.bg.greyscale.secondary,
        },

        '& .MuiTypography-root.MuiTypography-body2': {
          color: tokens.colors.original.brand.primary,
        },
      },
    },

    defaultOption: {
      '&&&&': {
        paddingTop: tokens.spacing['12'] + px(2),
        paddingBottom: tokens.spacing['12'] + px(2),
      },
    },

    clearButton: {
      '&&': {
        position: 'absolute',
        right: px(44), // TODO - fix нет в токенах
        top: px(30), // TODO - fix нет в токенах
        display: 'none',
        cursor: 'pointer',
      },
    },
  }),
);

export default useStyles;
